// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHouseholdFamilyTree_FamilyTreeNodeSettingsFragment = { __typename?: 'FamilyTreeNodeSettings', showIndividualOnTree: boolean, showNotesForIndividual: boolean };

export type GetHouseholdFamilyTree_FamilyTreePersonFragment = { __typename?: 'FamilyTreePerson', id: string, generation: number, isSynthetic: boolean, clientProfile: { __typename?: 'ClientProfile', id: string, displayName: string, isPrimary: boolean, firstName: string, dateOfBirth?: Time | null, dateOfDeath?: Time | null, isDeceased: boolean, notes?: string | null, address?: { __typename?: 'Address', id: string, stateCode: string } | null }, nodeSettings: (
    { __typename?: 'FamilyTreeNodeSettings' }
    & GetHouseholdFamilyTree_FamilyTreeNodeSettingsFragment
  ) };

export type GetHouseholdFamilyTree_MarriageFragment = { __typename?: 'Marriage', id: string, spouses: Array<string>, children: Array<string>, isCurrent: boolean, endReason?: Types.MarriageEndReason | null };

export type GetHouseholdFamilyTree_FamilyTreeWarningFragment = { __typename?: 'FamilyTreeWarning', id: string, clientProfileIds: Array<string>, message: string, type: Types.FamilyTreeWarningType };

export type GetHouseholdFamilyTree_FamilyTreeSettingsFragment = { __typename?: 'FamilyTreeSettings', showAge: boolean, showHiddenIndividuals: boolean, showNotes: boolean, showStateOfResidence: boolean, nodeConfigurations: Array<{ __typename?: 'EntityGraphNodeConfiguration', nodeID: string, xPosition?: number | null, yPosition?: number | null }> };

export type GetHouseholdFamilyTreeQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
  clientProfileWhere: Types.ClientProfileWhereInput;
}>;


export type GetHouseholdFamilyTreeQuery = { __typename?: 'Query', familyTree?: { __typename?: 'FamilyTree', household: { __typename?: 'Household', id: string, displayName: string }, primaryClients: Array<(
      { __typename?: 'FamilyTreePerson' }
      & GetHouseholdFamilyTree_FamilyTreePersonFragment
    )>, people: Array<(
      { __typename?: 'FamilyTreePerson' }
      & GetHouseholdFamilyTree_FamilyTreePersonFragment
    )>, marriages: Array<(
      { __typename?: 'Marriage' }
      & GetHouseholdFamilyTree_MarriageFragment
    )>, warnings: Array<(
      { __typename?: 'FamilyTreeWarning' }
      & GetHouseholdFamilyTree_FamilyTreeWarningFragment
    )>, settings: (
      { __typename?: 'FamilyTreeSettings' }
      & GetHouseholdFamilyTree_FamilyTreeSettingsFragment
    ) } | null, clientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string, displayName: string, firstName: string, onboardedIndividualSuggestion?: Array<{ __typename?: 'AISuggestion', id: string }> | null, relationships?: Array<{ __typename?: 'ClientProfileRelationship', id: string, type: Types.ClientProfileRelationshipType, fromClientProfile: { __typename?: 'ClientProfile', id: string }, toClientProfile: { __typename?: 'ClientProfile', id: string } }> | null } | null } | null> | null } };

export const Operations = {
  Query: {
    GetHouseholdFamilyTree: 'GetHouseholdFamilyTree' as const
  },
  Fragment: {
    GetHouseholdFamilyTree_FamilyTreeNodeSettings: 'GetHouseholdFamilyTree_FamilyTreeNodeSettings' as const,
    GetHouseholdFamilyTree_FamilyTreePerson: 'GetHouseholdFamilyTree_FamilyTreePerson' as const,
    GetHouseholdFamilyTree_Marriage: 'GetHouseholdFamilyTree_Marriage' as const,
    GetHouseholdFamilyTree_FamilyTreeWarning: 'GetHouseholdFamilyTree_FamilyTreeWarning' as const,
    GetHouseholdFamilyTree_FamilyTreeSettings: 'GetHouseholdFamilyTree_FamilyTreeSettings' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GetHouseholdFamilyTree_FamilyTreeNodeSettingsFragmentDoc = gql`
    fragment GetHouseholdFamilyTree_FamilyTreeNodeSettings on FamilyTreeNodeSettings {
  showIndividualOnTree
  showNotesForIndividual
}
    `;
export const GetHouseholdFamilyTree_FamilyTreePersonFragmentDoc = gql`
    fragment GetHouseholdFamilyTree_FamilyTreePerson on FamilyTreePerson {
  id
  clientProfile {
    id
    displayName
    isPrimary
    firstName
    dateOfBirth
    dateOfDeath
    isDeceased
    notes
    address {
      id
      stateCode
    }
  }
  generation
  isSynthetic
  nodeSettings {
    ...GetHouseholdFamilyTree_FamilyTreeNodeSettings
  }
}
    ${GetHouseholdFamilyTree_FamilyTreeNodeSettingsFragmentDoc}`;
export const GetHouseholdFamilyTree_MarriageFragmentDoc = gql`
    fragment GetHouseholdFamilyTree_Marriage on Marriage {
  id
  spouses
  children
  isCurrent
  endReason
}
    `;
export const GetHouseholdFamilyTree_FamilyTreeWarningFragmentDoc = gql`
    fragment GetHouseholdFamilyTree_FamilyTreeWarning on FamilyTreeWarning {
  id
  clientProfileIds
  message
  type
}
    `;
export const GetHouseholdFamilyTree_FamilyTreeSettingsFragmentDoc = gql`
    fragment GetHouseholdFamilyTree_FamilyTreeSettings on FamilyTreeSettings {
  showAge
  showHiddenIndividuals
  showNotes
  showStateOfResidence
  nodeConfigurations {
    nodeID
    xPosition
    yPosition
  }
}
    `;
export const GetHouseholdFamilyTreeDocument = gql`
    query GetHouseholdFamilyTree($householdId: ID!, $clientProfileWhere: ClientProfileWhereInput!) {
  familyTree(householdId: $householdId) {
    household {
      id
      displayName
    }
    primaryClients {
      ...GetHouseholdFamilyTree_FamilyTreePerson
    }
    people {
      ...GetHouseholdFamilyTree_FamilyTreePerson
    }
    marriages {
      ...GetHouseholdFamilyTree_Marriage
    }
    warnings {
      ...GetHouseholdFamilyTree_FamilyTreeWarning
    }
    settings {
      ...GetHouseholdFamilyTree_FamilyTreeSettings
    }
  }
  clientProfiles(where: $clientProfileWhere) {
    edges {
      node {
        id
        displayName
        firstName
        onboardedIndividualSuggestion {
          id
        }
        relationships {
          id
          type
          fromClientProfile {
            id
          }
          toClientProfile {
            id
          }
        }
      }
    }
  }
}
    ${GetHouseholdFamilyTree_FamilyTreePersonFragmentDoc}
${GetHouseholdFamilyTree_MarriageFragmentDoc}
${GetHouseholdFamilyTree_FamilyTreeWarningFragmentDoc}
${GetHouseholdFamilyTree_FamilyTreeSettingsFragmentDoc}`;

/**
 * __useGetHouseholdFamilyTreeQuery__
 *
 * To run a query within a React component, call `useGetHouseholdFamilyTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHouseholdFamilyTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHouseholdFamilyTreeQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      clientProfileWhere: // value for 'clientProfileWhere'
 *   },
 * });
 */
export function useGetHouseholdFamilyTreeQuery(baseOptions: Apollo.QueryHookOptions<GetHouseholdFamilyTreeQuery, GetHouseholdFamilyTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHouseholdFamilyTreeQuery, GetHouseholdFamilyTreeQueryVariables>(GetHouseholdFamilyTreeDocument, withFetchPolicyContext(options));
      }
export function useGetHouseholdFamilyTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHouseholdFamilyTreeQuery, GetHouseholdFamilyTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHouseholdFamilyTreeQuery, GetHouseholdFamilyTreeQueryVariables>(GetHouseholdFamilyTreeDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetHouseholdFamilyTreeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHouseholdFamilyTreeQuery, GetHouseholdFamilyTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHouseholdFamilyTreeQuery, GetHouseholdFamilyTreeQueryVariables>(GetHouseholdFamilyTreeDocument, withFetchPolicyContext(options));
        }
export type GetHouseholdFamilyTreeQueryHookResult = ReturnType<typeof useGetHouseholdFamilyTreeQuery>;
export type GetHouseholdFamilyTreeLazyQueryHookResult = ReturnType<typeof useGetHouseholdFamilyTreeLazyQuery>;
export type GetHouseholdFamilyTreeSuspenseQueryHookResult = ReturnType<typeof useGetHouseholdFamilyTreeSuspenseQuery>;
export type GetHouseholdFamilyTreeQueryResult = Apollo.QueryResult<GetHouseholdFamilyTreeQuery, GetHouseholdFamilyTreeQueryVariables>;